import "./appBanners.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import { useEffect, useState } from "react";
import DeviceFrame from "../../components/deviceFrame/deviceFrame";
import { Carousel } from "../../components/carousel/carousel";
import {
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import {
  arrayRemove,
  arrayUnion,
  doc,
  onSnapshot,
  updateDoc,
} from "firebase/firestore";
import { db, storage } from "../../firebase";
import { Delete } from "@mui/icons-material";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { ModalComponentDelete, ProgressDialog } from "../../components/modal";
import { green } from "@mui/material/colors";

const AppBanners = () => {
  const [banners, setBanners] = useState([]);
  const [valueFromSlider, setValueFromSlider] = useState(0);
  const [inputValue, setInputValue] = useState("");
  const [inputAddTagValue, setAddTagValue] = useState("");
  const [image, setImage] = useState(null);
  const [imageAddTag, setImageAddTag] = useState(null);
  const bannerRef = doc(db, "Alphabet", "home");
  const [open, setOpen] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);

  const handleClickOpenDialog = () => {
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleImageChange = (e) => {
    const selectedImage = e.target.files[0];

    if (selectedImage && selectedImage.type.startsWith("image/")) {
      setImage(selectedImage);
    } else {
      setImage(null);
      alert("Please select a valid image file.");
    }
  };

  const handleAddImageChange = (e) => {
    const selectedImage = e.target.files[0];
    if (selectedImage && selectedImage.type.startsWith("image/")) {
      setImageAddTag(selectedImage);
    } else {
      setImageAddTag(null);
      alert("Please select a valid image file.");
    }
  };

  const handleInputChange = (event) => {
    const { value, selectionStart } = event.target;
    const regex = /^[A-Za-z0-9]+$/;

    if (value === "" || regex.test(value)) {
      setInputValue(value);
    } else if (
      event.nativeEvent.inputType === "deleteContentBackward" &&
      selectionStart === 0
    ) {
      setInputValue("");
    }
  };
  const handleAddTagChange = (event) => {
    const { value, selectionStart } = event.target;
    const regex = /^[A-Za-z0-9]+$/;

    if (value === "" || regex.test(value)) {
      setAddTagValue(value);
    } else if (
      event.nativeEvent.inputType === "deleteContentBackward" &&
      selectionStart === 0
    ) {
      setAddTagValue("");
    }
  };
  const handleUpdateButton = () => {
    updateArrayItemByIndex();
  };

  const updateArrayItemByIndex = async () => {
    setOpen(true);
    if (image !== null) {
      const coverImgRef = ref(storage, "banners/" + image.name);

      uploadBytes(coverImgRef, image)
        .then((snapshot) => {
          getDownloadURL(snapshot.ref)
            .then(async (url) => {
              try {
                const mapData =
                  inputValue.trim().length === 0
                    ? { imageUrl: url }
                    : { imageUrl: url, tag: inputValue };
                banners[valueFromSlider] = mapData;
                await updateDoc(bannerRef, {
                  banners: banners,
                });
                setOpen(false);
                setImage(null);
              } catch (error) {
                setOpen(false);
                alert(error);
              }
            })
            .catch((error) => {
              setOpen(false);
              alert(error.message);
            });
        })
        .catch((error) => {
          setOpen(false);
          alert(error);
        });
    } else {
      try {
        const mapData =
          inputValue.trim().length === 0
            ? { imageUrl: banners[valueFromSlider].imageUrl }
            : { imageUrl: banners[valueFromSlider].imageUrl, tag: inputValue };

        banners[valueFromSlider] = mapData;
        await updateDoc(bannerRef, {
          banners: banners,
        });
        setOpen(false);
        setImage(null);
      } catch (error) {
        setOpen(false);
        alert(error);
      }
    }
  };

  const handleDeleteBanner = async () => {
    setOpen(true);
    const itemToDelete =
      inputValue.trim().length === 0
        ? { imageUrl: banners[valueFromSlider].imageUrl }
        : {
            imageUrl: banners[valueFromSlider].imageUrl,
            tag: banners[valueFromSlider].tag,
          };

    try {
      await updateDoc(bannerRef, {
        banners: arrayRemove(itemToDelete),
      });
      setOpen(false);
      alert("Item deleted successfully.");
      // console.log(`vls-${valueFromSlider} l-${banners.length}`)
      if (valueFromSlider + 1 === banners.length && valueFromSlider !==0 ) {
       window.location.reload();
      }
    } catch (error) {
      setOpen(false);
      alert("Error deleting item:", error);
    }
  };

  const handleAddBannerClick = async () => {
    if (imageAddTag === null) {
      alert("Please select an image for the banner.");
    } else {
      uploadImage();
    }
  };

  const uploadImage = async () => {
    setOpenDialog(false);
    setOpen(true);
    const coverImgRef = ref(storage, "banners/" + imageAddTag.name);

    uploadBytes(coverImgRef, imageAddTag)
      .then((snapshot) => {
        getDownloadURL(snapshot.ref)
          .then(async (url) => {
            const mapData =
              inputAddTagValue.trim().length === 0
                ? { imageUrl: url }
                : { imageUrl: url, tag: inputAddTagValue };
            try {
              await updateDoc(bannerRef, {
                banners: arrayUnion(mapData),
              });
              setOpen(false);

              setAddTagValue("");
              setImageAddTag(null);
              alert("Banner Added Successfully.");
            } catch (error) {
              setOpen(false);
              alert(error.message);
            }
          })
          .catch((error) => {
            setOpen(false);
            alert(error.message);
          });
      })
      .catch((error) => {
        setOpen(false);
        alert(error);
      });
  };

  useEffect(() => {
    if (banners && banners.length !== 0 && banners[valueFromSlider]) {
      setInputValue(
        banners[valueFromSlider].tag ? banners[valueFromSlider].tag : ""
      );
    }
  }, [banners]);

  useEffect(() => {
    document.title = "Wishallbook >> Banners";
    const unsubscribe = onSnapshot(bannerRef, (docSnap) => {
      try {
        if (docSnap.exists()) {
          const getBanners = docSnap.data().banners;
          if (getBanners) {
            setInitialLoading(false);
            setBanners(getBanners);
          }
        }
      } catch (error) {
        console.log("Error retrieving banners:", error);
      }
    });

    return () => unsubscribe();
  }, []);

  const updateValue = (newValue) => {
    if (valueFromSlider !== newValue) {
      setInputValue(banners[newValue].tag ? banners[newValue].tag : "");
      setImage(null);
      setValueFromSlider(newValue);
    }
  };

  return (
    <div className="list">
      <Sidebar />

      {initialLoading && (
        <div className="listContainer">
          <div className="intialItem">
            <CircularProgress />
          </div>
        </div>
      )}

      {!initialLoading && (
        
        <div className="listContainer">
          {banners.length > 0 && (
            <>
            <div className="topview">
            <Typography marginBottom={"20px"} sx={{fontSize:"25px" , color:"grey"}}>
            Active App Banners
                    </Typography>
            </div>
             <div className="bottomview">
             <div className="left">
                <DeviceFrame>
                  <Carousel data={banners} getSlideItem={updateValue} />
                </DeviceFrame>
              </div>
              <div className="right">
                <Card variant="outlined" sx={{ padding: "20px" }}>
                <Typography marginBottom={"20px"} sx={{fontSize:"15px" , color:"grey"}}>
                      Update current banner details.
                    </Typography>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ marginBottom: "20px" }}
                  >
                   
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                    />
                    {banners.length > 0 && (
                      <Delete
                        color="error"
                        sx={{ cursor: "pointer" }}
                        data-bs-toggle="modal"
                        data-bs-target="#bannerDelete"
                      />
                    )}
                  </Stack>

                  <TextField
                    id="outlined-multiline-static"
                    label="Tag (Optional)"
                    type="text"
                    value={inputValue}
                    onChange={handleInputChange}
                    helperText="Apply this tag to enable the banner's click functionality, directing users to the corresponding list of books or notes."
                    onKeyDown={() => {}}
                  />
                  <br />
                  <br />

                  <Button variant="contained" onClick={handleUpdateButton}>
                    Update
                  </Button>
                </Card>
                <Typography marginTop={"20px"} sx={{fontSize:"15px" , color:"grey"}}>
                     To add a new banner click "Add Banner".
                    </Typography>
                <Button
                  variant="contained"
                  sx={{ marginY: "20px" }}
                  onClick={handleClickOpenDialog}
                >
                Add Banner 
                </Button>
              </div>
            
             </div>
             </>
          )}
          {banners.length === 0 && (
            <div className="intialItem">
              <Typography textAlign={"center"}>
                Hey team, we noticed there's currently no banner set for the
                app's homepage. To enhance the user experience and keep them
                informed about upcoming features, promotions. Let's add a
                banner.
              </Typography>
              <Button
                variant="contained"
                sx={{ margin: "20px" }}
                onClick={handleClickOpenDialog}
              >
                Add Banner
              </Button>
            </div>
          )}
        </div>
      )}
      <Dialog open={openDialog}>
        <DialogTitle>Add Banner</DialogTitle>
        <DialogContent>
          <DialogContentText></DialogContentText>

          <input type="file" accept="image/*" onChange={handleAddImageChange} />
          <br />
          <br />

          <TextField
            id="outlined-multiline-static"
            label="Tag (Optional)"
            type="text"
            value={inputAddTagValue}
            onChange={handleAddTagChange}
            helperText="Apply this tag to enable the banner's click functionality, directing users to the corresponding list of books or notes."
            onKeyDown={() => {}}
          />
          <br />
          <br />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={handleAddBannerClick}>SUBMIT</Button>
        </DialogActions>
      </Dialog>
      <ProgressDialog loading={open} message={"Please wait..."} />
      <ModalComponentDelete
        title={"Confirmation"}
        body={"Do you still want to delete this banner from the banner list?"}
        cancelBtnText={"no"}
        modalID={"bannerDelete"}
        primaryBtnText={"yes"}
        primaryClick={handleDeleteBanner}
      />
    </div>
  );
};

export default AppBanners;
